/**
 * @generated SignedSource<<8c3782378308159f31890130bd3af5d2>>
 * @relayHash ca17349a7ce38fafb8a98b0fd48c67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa4bd6a2014828f5726238076216c6f4ed8db3bfcef1e6679c11b63b0a5efe8b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PolarisGlobalViewsSettingsDetailsPageQuery } from './PolarisGlobalViewsSettingsDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<PolarisGlobalViewsSettingsDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fa4bd6a2014828f5726238076216c6f4ed8db3bfcef1e6679c11b63b0a5efe8b",
    "metadata": {},
    "name": "PolarisGlobalViewsSettingsDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
